import React, { useEffect, useState } from 'react';
import axios from 'axios';

function numberFormat(v) {
  return Number(v || 0).toLocaleString('ko-KR');
}

function PlatformAdminNavbar() {
  const handleLogout = async () => {
    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true
      });
      const data = res.data || {};
      window.location.href = data.redirect || '/platform_admin/login';
    } catch (e) {
      window.location.href = '/platform_admin/login';
    }
  };

  return (
    <nav className="navbar navbar-dark bg-dark px-4">
      <span className="navbar-brand">플랫폼 관리자</span>
      <div>
        <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light">셀러관리</a>{' '}
        <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light">상점관리</a>{' '}
        <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light">주문관리</a>{' '}
        <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light">클레임</a>{' '}
        <button type="button" onClick={handleLogout} className="btn btn-sm btn-danger">로그아웃</button>
      </div>
    </nav>
  );
}

export default function PlatformAdminIndex() {
  const [data, setData] = useState({
    total_shops: 0,
    total_members: 0,
    today_orders: 0,
    today_sales: 0,
    pending_claims: 0,
    top_shops: []
  });

  useEffect(() => {
    axios.get('/api/platform_admin/', { withCredentials: true })
      .then((res) => {
        const d = res.data || {};
        if (!d.ok) {
          if (d.redirect) {
            window.location.href = d.redirect;
          }
          return;
        }
        setData(d);
      })
      .catch((err) => {
        const d = err?.response?.data || {};
        if (d.redirect) {
          window.location.href = d.redirect;
        }
      });
  }, []);

  return (
    <div className="bg-light" style={{ minHeight: '100vh' }}>
      <PlatformAdminNavbar />

      <div className="container my-4">
        <h4 className="mb-4">📊 플랫폼 현황</h4>

        <div className="row g-3 mb-4">
          <div className="col-md-3">
            <div className="card shadow-sm">
              <div className="card-body text-center">
                <div className="text-muted">전체 상점</div>
                <h3>{numberFormat(data.total_shops)}</h3>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow-sm">
              <div className="card-body text-center">
                <div className="text-muted">전체 회원</div>
                <h3>{numberFormat(data.total_members)}</h3>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow-sm">
              <div className="card-body text-center">
                <div className="text-muted">오늘 주문</div>
                <h3>{numberFormat(data.today_orders)}</h3>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card shadow-sm">
              <div className="card-body text-center">
                <div className="text-muted">오늘 매출</div>
                <h3>{numberFormat(data.today_sales)}원</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-3">
          <div className="col-md-6">
            <div className="card shadow-sm h-100">
              <div className="card-header bg-white fw-bold">
                🚨 처리 대기 클레임
              </div>
              <div className="card-body text-center">
                <h2 className="text-danger">{data.pending_claims}</h2>
                <a href="/platform_admin/claims" className="btn btn-sm btn-outline-danger">클레임 관리</a>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card shadow-sm h-100">
              <div className="card-header bg-white fw-bold">
                🏆 매출 TOP 상점
              </div>
              <div className="card-body p-0">
                <table className="table mb-0">
                  <thead>
                    <tr>
                      <th>상점</th>
                      <th className="text-end">매출</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(data.top_shops || []).map((s) => (
                      <tr key={s.id}>
                        <td>
                          <a href={`/platform_admin/shop_view?id=${s.id}`}>
                            {s.name}
                          </a>
                        </td>
                        <td className="text-end">
                          {numberFormat(s.total_sales)}원
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}